import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  const { t } = useTranslation("common");
  return (
    <section className="container py-24 text-center">
      <p className="text-xs uppercase tracking-[0.25em] text-primary font-semibold">404</p>
      <h1 className="mt-3 text-5xl md:text-6xl">{t("notFound.title")}</h1>
      <p className="mt-4 max-w-md mx-auto text-muted-foreground">
        {t("notFound.body")}
      </p>
      <div className="mt-8">
        <Link to="/"><Button size="lg">{t("notFound.cta")}</Button></Link>
      </div>
    </section>
  );
}
